import request from "@/utils/request";
import type {
  ApiResponse,
  LoginSuccessResult,
  PasswordLoginParams,
  UserInfoResult,
  ChangePasswordParams,
  VerifyCodeParams,
  ScanQrcodeLoginSchema,
} from "@/types/apis";

// 帐号密码登录
export const passwordLogin = (data: PasswordLoginParams) =>
  request.post<ApiResponse<LoginSuccessResult>>("/purchase/auth/login", data);

// 采购人员退出登录
export const logoutApp = () =>
  request.post<ApiResponse>("/purchase/auth/logout");

// 获取采购人员当前信息
export const getCurrentUserInfo = () =>
  request.get<ApiResponse<UserInfoResult>>("/purchase/auth/info");

// 通过用户id查询用户详情信息
export const getUserInfoById = (userId: number | string) =>
  request.get<ApiResponse<UserInfoResult>>(`/purchase/user/detail/${userId}`);

// 修改密码
export const changePassword = (data: ChangePasswordParams) =>
  request.put<ApiResponse>(
    "/purchase/user/change/password",
    {},
    { params: data },
  );

// 校验验证码
export const verifyCode = (data: VerifyCodeParams) =>
  request.put<ApiResponse>("/purchase/auth/verify", {}, { params: data });

// 根据code查询用户信息
export function loginByWecomCode(data: ScanQrcodeLoginSchema) {
  return request.post(`/wecom/checkCode`, {}, { params: data });
}
